const normalizeExternalUrl = (value?: string) => {
  const trimmed = value?.trim();
  if (!trimmed) {
    return '';
  }

  try {
    return new URL(trimmed).toString();
  } catch {
    return '';
  }
};

export const publicTreeBrandingUrl =
  normalizeExternalUrl(process.env.REACT_APP_PUBLIC_TREE_BRAND_URL) ||
  'https://familytree.inguva.com/';
